export default __webpack_public_path__ + "static/media/SheffieldNorthernGeneral-MedicalSameDayEmergencyCare(SDEC)NGHSDECCriteria.b6832304.jpg";